// Module
var code = "<iframe id=\"{{ $ctrl.id }}\" height=\"{{ $ctrl.height }}\" style=\"width:100%;border:none\"></iframe> ";
// Exports
module.exports = code;